import React from 'react';
import ReactDOM from 'react-dom';
import {
    extend,
    mobiscroll,
    PropTypes
} from './frameworks/react';
import { Navigation } from './classes/navigation';

import { MbscNavigationBase, MbscNavItemBase } from './classes/navigation-base.react';

class MbscNavBaseComponent extends MbscNavigationBase {
    constructor(props, type) {
        super(props);
        this.type = type;
    }

    componentDidMount = () => {
        // get settings from state
        var settings = extend({}, this.state.options, { type: this.type });
        // get the DOM node
        var DOMNode = ReactDOM.findDOMNode(this);
        // initialize the mobiscroll
        this.instance = new Navigation(DOMNode, settings);

        // pass the instance to all children components
        for (var i = 0; i < this.childComponents.length; i++) {
            this.childComponents[i].setInstance(this.instance);
        }
    }

    componentDidUpdate = () => {
        if (this.optimizeUpdate.updateChildren) {
            this.instance.refresh(true); // refresh without scroll
        }
    }

    render = () => {
        return <div className={this.initialCssClass + ' mbsc-cloak'}>{this.renderChildren()}</div>;
    }
}

MbscNavBaseComponent.propTypes = {
    ...MbscNavigationBase.propTypes,
    display: PropTypes.oneOf(['top', 'bottom', 'inline']),
    moreText: PropTypes.string,
    moreIcon: PropTypes.string,
    menuText: PropTypes.string,
    menuIcon: PropTypes.string,
    children: function (props, propName, componentName) {
        var prop = props[propName];
        var error;

        React.Children.forEach(prop, function (el) {
            if (error) return;

            // Make sure child is a label
            if (el.type !== MbscNavItem) {
                error = new Error(
                    '`' + componentName + '` only accepts `NavItem`.'
                );
            }
        });

        return error;
    }
};

class MbscBottomNav extends MbscNavBaseComponent {
    constructor(props) {
        super(props, 'bottom');
    }
}

class MbscHamburgerNav extends MbscNavBaseComponent {
    constructor(props) {
        super(props, 'hamburger');
    }
}

class MbscTabNav extends MbscNavBaseComponent {
    constructor(props) {
        super(props, 'tab');
    }
}


class MbscNavItem extends MbscNavItemBase {
    constructor(props) {
        super(props);
    }

    render = () => {
        return <div data-icon={this.props.icon} data-id={this.id} data-selected={this.props.selected} data-disabled={this.props.disabled} data-badge={this.props.badge} onClick={this.props.onClick}>{this.props.children}</div>;
    }

    componentWillReceiveProps = (newProps) => {
        if (this._instance) {
            if (this.props.selected !== newProps.selected) {
                if (newProps.selected) {
                    this._instance.select(this._DOMNode);
                } else {
                    this._instance.deselect(this._DOMNode);
                }
            }

            if (this.props.disabled !== newProps.disabled) {
                if (newProps.disabled) {
                    this._instance.disable(this._DOMNode);
                } else {
                    this._instance.enable(this._DOMNode);
                }
            }

            if (this.props.badge !== newProps.badge) {
                this._instance.setBadge(this._DOMNode, newProps.badge);
            }
        }
    }
}

MbscNavItem.propTypes = {
    ...MbscNavItemBase.propTypes,
    badge: PropTypes.string
};

mobiscroll.BottomNav = MbscBottomNav;
mobiscroll.HamburgerNav = MbscHamburgerNav;
mobiscroll.TabNav = MbscTabNav;
mobiscroll.NavItem = MbscNavItem;

export default mobiscroll;


// WEBPACK FOOTER //
// ./src/js/lib/mobiscroll/navigation.react.jsx